<template>
    <span class="i-layout-header-trigger i-layout-header-trigger-min" v-if="user!=null">
        <Dropdown :trigger="isMobile ? 'click' : 'hover'" class="i-layout-header-user" :class="{ 'i-layout-header-user-mobile': isMobile }" @on-click="handleClick">
            <Avatar size="small" :src="'images/userAvatar.png'" />
            <span class="i-layout-header-user-name" v-if="!isMobile">{{ user.name }}</span>
            <DropdownMenu slot="list">
                <i-link to="/polymerization">
                    <DropdownItem v-if="user.roleList[0].roleId == 1">
                        <Icon type="ios-exit-outline" />
                        <span>{{ $t('basicLayout.user.polymerization') }}</span>
                    </DropdownItem>
                    <DropdownItem v-if="user.roleList[0].roleId != 1">
                        <Icon type="ios-exit-outline" />
                        <span>{{ $t('basicLayout.user.polymerization1') }}</span>
                    </DropdownItem>
                </i-link>
                <i-link to="/setting/user">
                    <DropdownItem>
                        <Icon type="ios-contact-outline" />
                        <span>{{ $t('basicLayout.user.center') }}</span>
                    </DropdownItem>
                </i-link>
                <i-link to="/setting/account">
                    <DropdownItem>
                        <Icon type="ios-settings-outline" />
                        <span>{{ $t('basicLayout.user.setting') }}</span>
                    </DropdownItem>
                </i-link>
                <DropdownItem divided name="logout">
                    <Icon type="ios-log-out" />
                    <span>{{ $t('basicLayout.user.logOut') }}</span>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    </span>
</template>
<script>
    import { mapState, mapActions } from 'vuex';
    import dataUtils from "../../../utils/dataUtils";
    import Setting from "../../../setting";

    export default {
        name: 'iHeaderUser',
        computed: {
            ...mapState('admin/user', [
                'info'
            ]),
            ...mapState('admin/layout', [
                'isMobile',
                'logoutConfirm'
            ])
        },
        data(){
            return {
                user:null
            }
        },
        methods: {
            ...mapActions('admin/account', [
                'logout'
            ]),
            handleClick (name) {
                if (name === 'logout') {
                    this.logout({
                        confirm: this.logoutConfirm,
                        vm: this
                    });
                }
            }
        },
        mounted(){
            this.user = dataUtils.getData(Setting.key.userInfo)
        }
    }
</script>
